<template>
  <div class="flex items-center justify-between">
    <img :src="logoPath" class="h-10" alt="logo" />
    <div class="flex items-center gap-x-2">
      <LanguageSwitcher />
      <ElDropdown
        trigger="click"
      >
        <span>
          <ElAvatar> {{getUserFirstLetter}} </ElAvatar>
        </span>
        <ElDropdownMenu>
          <ElDropdownItem>
            <span
              @click="logout"
            >LogOut</span>
          </ElDropdownItem>
        </ElDropdownMenu>
      </ElDropdown>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import Hamburger from '@/components/Hamburger/index.vue'
import LanguageSwitcher from '@/components/UILibrary/LanguageSwitcher.vue'
import CompanyLogo from '@/views/logos/company-logo.vue'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'Navbar',
  components: {
    CompanyLogo,
    LanguageSwitcher,
    Hamburger
  }
})
export default class extends Vue {
  logoPath = 'https://res.cloudinary.com/whitecarrot/image/upload/v1667657049/company_logo/whitecarrot/full_text_logo_cpbn17.png'

  async logout() {
    await this.$router.push('/logout')
  }

  get getUserFirstLetter(): string {
    return UserModule.firstName.charAt(0)
  }
}
</script>
